import SocketConnector from "./SocketConnector"

export default class GameConnector extends SocketConnector {

    constructor(socket)  {
        super(socket)
        this.verbose_name = "GameConnector:";
        this.controller_id = "game-rpc";
    
        this.GAME_TYPE_ID_BACKGAMMON_NOT_SET = 0;
        this.GAME_TYPE_ID_BACKGAMMON_LONG  = 1;
        this.GAME_TYPE_ID_BACKGAMMON_SHORT = 2;
    
    
        this.GAME_STATUS_NONE               = 0;
        this.GAME_STATUS_SEARCH_OPPONENT    = 10;
        this.GAME_STATUS_WAIT_PLAYERS       = 20;
        this.GAME_STATUS_IN_PLAY            = 30;
        this.GAME_STATUS_FINISHED           = 40;
        this.GAME_STATUS_CANCELED           = 50;
    
        this.TYPE_ID_TRAIN        = 0;
        this.TYPE_ID_CUSTOM_DUEL  = 1;
        this.TYPE_ID_CUSTOM_MATCH = 2;
        this.TYPE_ID_TOURNAMENT   = 3;
    
        this.myUuid = null;
        this.gameUuid = null;
                
        this.cb_game_list_changed = (data) => {this.__log("cb_game_list_changed", data); };
        this.cb_my_game_started = (data)   => {this.__log("cb_my_game_started", data); };
        this.cb_my_game_canceled = (data)  => {this.__log("cb_my_game_canceled", data);};
        this.cb_revenge_request = (data)   => {this.__log("cb_revenge_request", data);};
    
        this.__setupCallbacks();             
    }
    
    BOT_SKILL_LEVELS() {
        return [
            "dummy",       
            "novice",      
            "simple" ,     
            "middle" ,     
            "advanced",    
            "professional",
            "expert",    
            "master" ,   
            "champion" , 
            "guru",  
        ]
    }

    SPEED_LEVELS() {
        return ["express", "fast", "normal", "slow", "long"]
    }

    ///**
    // * Set current player_uuid
    // *  call this method when you find_out uuid
    // * @param player_uuid
    // */
    //async setMyUuid(player_uuid) {
    //    this.my_uuid = player_uuid;
    //};

    __setupCallbacks() {        
        this.socket.on("user_info", (data) => {
            this.__log("user_info", data);
            this.myUuid   = data.uuid;
            this.gameUuid = data.game_uuid;
        });

        this.socket.on("gameStatusChanged", (data) => {
            this.__log("gameStatusChanged", data);
            this.cb_game_list_changed(data);
            var is_my = false;
            var status;
            try {
                is_my = ( data.game.player_a_uuid == this.myUuid ||  data.game.player_b_uuid == this.myUuid);
                status = data.game.status;
            } catch (e) { }
            if(!is_my)
                return;

            if(status == this.GAME_STATUS_IN_PLAY) {
                this.__log("My game Started "+data.game.uuid, data);
                this.cb_my_game_started(data);
            } else if(status == this.GAME_STATUS_CANCELED) {
                this.__log("My game canceled "+data.game.uuid, data);
                this.cb_my_game_canceled(data);
            } else if(status == this.GAME_STATUS_WAIT_PLAYERS && data.game.player_b_uuid == this.myUuid) {
                this.__log("On game revenge request "+data.game.uuid, data);
                this.cb_revenge_request(data);
            }
        });

        //this.socket.on("connected")
    };


    // /**
    //  * Callback for adding two numbers.
    //  *
    //  * @callback gameCallback
    //  * @param {object} err - error.
    //  * @param {object} result
    //  *
    //  * @param {object} result.game  the created game
    //  */
    ///**
    // * Sample of create game options
    // * @returns {{game_type: number, time_for_one_step: number, enable_mars: boolean, enable_koks: boolean, enable_double_cube: boolean, max_score: number, bet_price: number, bet_currency: string, caption: string, enable_watchers: boolean, password: string, skill_level: string}}
    // */
    //async GameCreateOptionsSample() {
    //    return {
    //        game_type : 1,
    //        time_for_one_step : 600,
    //        enable_mars : false,
    //        enable_koks : false,
    //        double_cube_enable : false,
    //        enable_paritet: false,
    //        max_score : 3,
    //        bet_price : 1,
    //        bet_currency : "Cr",
    //        caption : "Название",
    //        enable_watchers : true,
    //        password : "",
    //        skill_level : "novice"  // for training only
    //    };
    //};

    /**
     *
     * @param options {Object}
     * @param options.game_type  {string} GAME_TYPE_ID_BACKGAMMON_LONG | GAME_TYPE_ID_BACKGAMMON_SHORT
     * @param options.time_for_one_step {number} Время на один ход
     * @param options.enable_mars
     * @param options.enable_koks
     * @param options.double_cube_enable
     * @param options.enable_paritet
     * @param options.max_score
     *
     * @param options.bet_price   - размер ставки игры
     * @param options.bet_currency  3-х буквенное название валюты - используй текущую валюту по умолчанию.
     * @param options.caption {string}
     * @param options.enable_watchers {boolean}
     * @param options.password {string}  пароль для закрытых игр
     *
     * @param options.skill_level {string}  Только для игры с ботом
     * 
     *      "dummy"         => Yii::t("app","dummy"),
            "novice"        => Yii::t("app","novice"),
            "simple"        => Yii::t("app","simple"),
            "middle"        => Yii::t("app","middle"),
            "advanced"      => Yii::t("app","advanced"),
            "professional"  => Yii::t("app","professional"),
            "expert"        => Yii::t("app","expert"),
            "master"        => Yii::t("app","master"),
            "champion"      => Yii::t("app","champion"),
            "guru"          => Yii::t("app","guru"),

     * @param options.speed_level {string}  
     * 
     *      "express"   => Yii::t("app","express"),
            "fast"   => Yii::t("app","fast"),
            "normal" => Yii::t("app","normal"),
            "slow"   => Yii::t("app","slow"),
            "long"   => Yii::t("app","long"),
            "custom"   => Yii::t("app","Custom"),

     *
     */
    async doCreate(options) {
        if(options.game_type === undefined)
            options.game_type = this.GAME_TYPE_ID_BACKGAMMON_LONG;

        return this.__call("create", options);
    };


    async doTrain(options) {
        if(options.game_type === undefined)
            options.game_type = this.GAME_TYPE_ID_BACKGAMMON_LONG;
    
        return  this.__call("train", options);
    };

    async doJoin(game_uuid) {
        return this.__call("join", { game_uuid: game_uuid});
    };
    
    /**
     * @deprecated replaced by doGetListSearch
     */
    async doGetList(ownership, status, page, page_size) {
        return this.doGetListSearch( {
                ownership: ownership,
                status: status
            },{
                page: page,
                pageSize: page_size
            }            
        );
    };

    /**
     * Get list of games
     *  My games finished or active
     *  Joinable games
     *  Finished games
     * Example: g_game_connector.doGetListSearch( { joinable: "true" }, {page:0, pageSize:20} , function(e,r) {} );
     *
     * @param search
     * @param search.ownership  "all" | "my"
     * @param search.status  "all" | "active" | "finished'
     * @param search.joinable  "all"  | "true"   - get only joinable
     * @param search.type_id  Training or match
     * @param pagination
     * @param pagination.page   int
     * @param pagination.pageSize  int     
     */
    async doGetListSearch(search, pagination) {
        return this.__call("list", {
            pagination: pagination,
            search: search
        });
    };


    /**
     *
     * @param game_uuid uuid of game     
     */
    async doView(game_uuid) {
        return this.__call("view", {
            game_uuid: game_uuid
        });
    };


    /**
     *
     * Create game revenge
     *
     * you need wait while game will started or canceled
     * @param game_old_uuid UUId of previous game
     * @param cb function(e,r)
     *
     *
     */
    async doRevengeCreate(game_old_uuid) {
        return this.__call("create-revenge", {
            game_uuid: game_old_uuid
        });
    };


    async doRevengeConfirm(game_uuid) {
        return this.__call("confirm", {
            game_uuid: game_uuid
        });
    };


    async doRevengeReject(game_uuid) {
        this.doCancel(game_uuid);
    };


    /**
     * Cancel game if it possible
     * @param game_uuid UUId of  game
     * @param cb function(e,r)
     */
    async doCancel(game_uuid) {
        return this.__call("cancel", {
            game_uuid: game_uuid
        });
    };

    /**
     * callback when game list changed.
     * @param cb
     */
    setCallbackGameListChanged(cb) {
        this.__log("setCallbackGameListChanged");
        this.cb_game_list_changed = cb;
    };

    /**
     * Callback when YOUR game begins
     * @param cb function(data)
     *        data.game     game description
     */
    setCallbackGameStarted(cb) {
        this.__log("setCallbackGameStarted");
        this.cb_my_game_started = cb;
    };
    /**
     * Callback when YOUR revenge game canceled
     * @param cb function(data)
     *        data.game     game description
     */
    setCallbackGameCanceled(cb) {
        this.__log("setCallbackGameCanceled");
        this.cb_my_game_canceled = cb;
    };
    /**
     * Callback when YOUR revenge game canceled
     * @param cb function(data)
     *        data.game     game description
     */
    setCallbackRevengeRequest(cb) {
        this.__log("setCallbackRevengeRequest");
        this.cb_revenge_request = cb;
    };

}
        











